const Header = () => {
  return (
    <div className='col'>
      <header className='hero'>
        <div className='hero__content'>
          <h1>Learn to code by watching others</h1>
          <p>
            See how experienced developers solve problems in real-time. Watching
            scripted tutorials is great, but understanding how developers think
            is invaluable.
          </p>
        </div>
      </header>
    </div>
  );
};
export default Header;
